import { type ProductImage, type Product, type Category } from '@prisma/client'
import { Link } from '@remix-run/react'
import { getProductImgSrc } from '#app/utils/misc.tsx'
import defaultProductImage from '/img/image.png'

interface Props {
	products: Array<
		Pick<Product, 'id' | 'name' | 'slug'> & {
			images: Array<Pick<ProductImage, 'id' | 'altText'>>
		} & {
			category: Pick<Category, 'slug'>
		}
	>
}

export const ProductsList = ({ products }: Props) => {
	return (
		<ul className="flex w-full flex-col items-start justify-start gap-4 delay-200">
			{products.map(product => (
				<li key={product.id} className="w-full">
					<Link
						// todo: change
						to={`/products/${product.category.slug}/${product.id}/${product.slug}`}
						className="flex w-full items-center gap-4 rounded-md bg-muted"
					>
						<img
							alt={product.images[0]?.altText ?? 'Product image'}
							src={
								product.images[0]?.id
									? getProductImgSrc(product.images[0].id)
									: defaultProductImage
							}
							className="h-24 w-24 rounded-xl rounded-r-none object-cover"
						/>
						<div className="flex w-full flex-col overflow-hidden">
							<span className="w-full overflow-hidden text-ellipsis whitespace-nowrap text-left max-sm:text-xs">
								{product.name}
							</span>
						</div>
					</Link>
				</li>
			))}
		</ul>
	)
}
